import {
  toggleClass,
  toggleAttribute,
  addClass,
  removeClass,
} from '../../assets/js/utility';

class Header {
  constructor() {
    this.menuIcon = document.querySelector('#mobile-menu-icon');
    this.mainNav = document.querySelector('.main-site-nav .dynamic-nav');
    this.allNavLinks = this.mainNav
      ? this.mainNav.querySelectorAll('.nav-link')
      : null;
    this.breakpoint = 1300; // match nav.js breakpoint

    if (this.menuIcon) {
      this.menuIcon.addEventListener('click', () => {
        this.toggleMobileMenuNav();
      });

      this.menuIcon.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          this.toggleMobileMenuNav();
        }
      });
    }

    // horizontal only when not using mobile menu
    if (this.mainNav) {
      window.addEventListener('resize', () => this.setNavigationOrientation());

      // run on init
      this.setNavigationOrientation();
      this.setKeyboardAccessibility();
    }
  }

  /**
   * Removes tab-ability of header items on mobile if the menu is closed so that
   * users on smaller laptops are not tabbing through an invisible menu
   */
  setKeyboardAccessibility() {
    let navLinkTabbable = this.allNavLinks[0].getAttribute('tabindex') != '-1';
    let mobileMenuOpen =
      window.innerWidth < this.breakpoint &&
      this.menuIcon.classList.contains('is-open');

    // nav should be tabbable when not collapsed inside closed mobile menu
    if (
      (window.innerWidth >= this.breakpoint && !navLinkTabbable) ||
      mobileMenuOpen
    ) {
      for (const link of this.allNavLinks) {
        link.removeAttribute('tabindex');
      }
    } else {
      for (const link of this.allNavLinks) {
        link.setAttribute('tabindex', '-1');
      }
    }
  }

  toggleMobileMenuNav() {
    toggleClass(this.menuIcon, 'is-open');
    toggleAttribute(this.menuIcon, 'aria-expanded');
    this.setKeyboardAccessibility();
  }

  setNavigationOrientation() {
    if (window.innerWidth >= this.breakpoint) {
      addClass(this.mainNav, 'horizontal');
    } else {
      removeClass(this.mainNav, 'horizontal');
    }

    this.setKeyboardAccessibility();
  }
}
export default Header;
